import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import ConfigService from "./ConfigService";

const reactPlugin = new ReactPlugin();
const config = ConfigService.getConfig();
const appInsightsPromise = config
  .then((data) => {
    const connectionString = (
      data as unknown as { applicationInsights?: { connectionString?: string } }
    ).applicationInsights?.connectionString;

    if (!connectionString) {
      console.warn("Application Insights connection string not found");
      return null;
    }

    const appInsights = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        extensions: [reactPlugin],
        extensionConfig: {},
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableExceptionTracking: false,
        // Disable tracking during page unload to prevent aborted requests
        disableFetchTracking: false,
        maxBatchInterval: 5000, // Batch telemetry to reduce requests
      },
    });

    appInsights.loadAppInsights();

    // Add telemetry initializer to filter out aborted requests
    appInsights.addTelemetryInitializer((_envelope) => {
      // Don't track requests during authentication redirects
      if (
        window.location.hash.includes("code=") ||
        window.location.hash.includes("state=")
      ) {
        return false;
      }
      return true;
    });

    return appInsights;
  })
  .catch((error) => {
    console.error("Failed to initialize Application Insights:", error);
    return null;
  });

export { reactPlugin, appInsightsPromise };
